import {View,TouchableOpacity, Text} from 'react-native-web';
import { ButtonText, ButtonListText } from './Text';

const ButtonUser=({text, onPress, wsize})=>{
return(
  <TouchableOpacity onPress={onPress} style ={{backgroundColor:'#F9BA49', width:wsize, height:45,alignItems:'center', justifyContent:'center',marginTop:15, borderRadius:16, shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5, maxWidht:100}} >
   
        <ButtonText color={'#252525'} text={text}/>
    </TouchableOpacity>);}

const ButtonBlack=({text, onPress, wsize})=>{

return(
  <TouchableOpacity onPress={onPress} style ={{backgroundColor:'#252525', width:wsize, height:45,alignItems:'center', justifyContent:'center',marginTop:15, borderRadius:16, shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5, borderWidth:1.8, borderColor:'#F9BA49',maxWidht:100}} >
        <ButtonText color={'#F9BA49'} text={text}/>
    </TouchableOpacity>);}

const ButtonList=({text, onPress, wsize})=>{

  return(
    <TouchableOpacity onPress={onPress} style ={{backgroundColor:'#303030', width:wsize, height:30,alignItems:'center', justifyContent:'center',marginTop:15, borderRadius:16, shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5, borderWidth:1.8, borderColor:'#F9BA49', }} >
    
          <ButtonListText color={'#F9BA49'} text={text}/>
      </TouchableOpacity>);}

const ButtonList2=({text, onPress, wsize})=>{

  return(
    <TouchableOpacity onPress={onPress} style ={{backgroundColor:'#303030', width:wsize, height:45,alignItems:'center', justifyContent:'center', borderRadius:16, shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5, borderWidth:1.8, borderColor:'#F9BA49', }} >
    
          <ButtonListText color={'#F9BA49'} text={text}/>
      </TouchableOpacity>);}

function Button(props) {
  return (
    <TouchableOpacity
      style={{
        width: props.width,
        height:40,
        backgroundColor: props.color,
        shadowColor: '#101010',
        shadowRadius: 10,
        shadowOpacity: 0.75,
        shadowOffset: { width: 10, height: 10 },
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius:10,
        borderWidth:1,
        borderColor:props.borderColor,
        marginTop:props.marginTop
      }}
      onPress={props.onPress}
      >
      <Text style={{ color: props.textColor, fontWeight: '800', fontSize: 20 }}>
        {props.text}
      </Text>
    </TouchableOpacity>
  );
}


export  {ButtonUser, ButtonBlack, ButtonList, ButtonList2, Button}